<div class='admin'>
    <app-beheer-nav></app-beheer-nav>
    <!-- Only show once statistic is loaded-->
    <div class='adminpanel' *ngIf='statistic'>
    
    </div>
</div>